// src/app/components/StatsSection.js
"use client";

import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { useEffect, useState } from "react";

export default function StatsSection() {
  const [hasAnimated, setHasAnimated] = useState(false);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = [
    { value: 30, suffix: "+", label: "Projects Completed" },
    { value: 1, suffix: "+", label: "Successful Years" },
    { value: 98, suffix: "%", label: "Client Retention" },
    { value: 6, suffix: "+", label: "Countries" },
  ];

  useEffect(() => {
    setHasAnimated(false);
    return () => setHasAnimated(false);
  }, []);

  return (
    <div ref={ref} className="bg-gradient-to-r from-[#00063A] via-[#425fae] to-[#00063A] text-white py-12 px-4 text-center relative z-10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12">
        {stats.map((stat, index) => (
          <div key={index} className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-3">
              {inView && !hasAnimated ? (
                <CountUp
                  end={stat.value}
                  duration={2.75}
                  delay={index * 0.25}
                  onEnd={() => index === stats.length - 1 && setHasAnimated(true)}
                  className="inline-block"
                />
              ) : (
                <span>{hasAnimated ? stat.value : 0}</span>
              )}
              {stat.suffix}
            </h2>
            <p className="text-lg md:text-xl text-gray-300 mt-2">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}